// extracted by mini-css-extract-plugin
export var darkMode = "_1e-0";